import { Tooltip } from "@mui/material";
import { cn } from "@utils";
import { ReactNode } from "react";

/** A short rounded label that explains itself on hover or focus; `className` sets its colours. */
export const Pill = ({
  className,
  description,
  children,
}: {
  className: string;
  description: string;
  children: ReactNode;
}) => (
  <Tooltip title={description} describeChild>
    <span
      tabIndex={0}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border border-solid px-2.5 py-px text-sm font-semibold",
        className
      )}
    >
      {children}
    </span>
  </Tooltip>
);
